import axios from "axios";
require("dotenv").config();

console.log(`Rodando requests para ${process.env.REACT_APP_BASE_URL}`);

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
  //baseURL: url
});
api.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

export default api;
